import { makeStyles } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';

export const useStyles = makeStyles({
  desactivate: {
    backgroundColor: amber[100]
  }
})